import { useQuery } from '@apollo/client';
import { practitionerFiltersQuery } from 'Services/BeGateway/Practitioner/__generated__/practitionerFiltersQuery';
import { useMemo } from 'react';

import { PRACTITIONER_FILTERS_QUERY } from 'Services/BeGateway/Practitioner/practitioner.services';
import { countryRequiresState } from 'Account/hooks';
import { Namespace, ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';
import { BEGatewayQueryContext, defaultQueryConfig } from 'utils/apollo';
import { getISOLanguageFromCode } from 'utils/getISOLanguageFromCode';

export default ({
  country,
  region,
}: {
  country: {
    value: string;
    label: string;
  };
  region: {
    value: string;
    label: string;
  } | null;
}) => {
  const { t: translateLanguageName } =
    useTranslation<Namespace<'languages'>>('languages');

  const { data, loading, error } = useQuery<practitionerFiltersQuery>(
    PRACTITIONER_FILTERS_QUERY,
    {
      variables: {
        types: ['THERAPIST', 'COACH'],
        country: country.value,
        state: Boolean(region?.value) ? region?.value : null,
      },
      ...defaultQueryConfig,
      ...BEGatewayQueryContext,
      skip:
        !country.value ||
        (countryRequiresState(country.value) && !region?.value),
    },
  );

  const availableLanguages = useMemo(
    () =>
      data?.practitionerFilters?.languages?.map(lang => {
        const languageLabels = getISOLanguageFromCode(lang.name);

        return {
          value: lang.name,
          label: `${translateLanguageName(
            languageLabels.en as ParseKeys<Namespace<'languages'>>,
          )} (${languageLabels.native})`,
        };
      }) || [],
    [data, translateLanguageName],
  );

  return {
    availableLanguages,
    loading,
    error,
  };
};
